import ReactPixel from "react-facebook-pixel"

const advancedMatching = {} // optional, more info: https://developers.facebook.com/docs/facebook-pixel/pixel-with-ads/conversion-tracking#advanced_match
const options = {
  autoConfig: true, // set pixel's autoConfig
  debug: true // enable logs
}
const pixel = ReactPixel
pixel.init("183535255928846", advancedMatching, options)

export default pixel
